<template>
  <div class="single-view services">
    <view-background
      ref="background"
      :background="background"/>

    <hero-block
      :title="title"
      :subtitle="subtitle"
      :animate-in="entering"
      :animation-direction="animationDirection" />

    <content-wrapper>
      <two-columns-content>
        <template slot="header">
          <header class="block--header">
            <h2>La scienza al servizio della Natura.</h2>
          </header>
        </template>

        <template slot="right-column">
          <span class="anchor" data-anchor="Analisi di laboratorio"></span>
          <h3>Analisi di laboratorio</h3>
          <h4>POLOLAB fornisce servizi di analisi e assistenza tecnica ad elevata specializzazione per i settori enologico ed agroalimentare.</h4>

          <p>
            Il Laboratorio Polo rappresenta oggi un'eccellenza nel settore delle analisi enologiche. Fondata nel 1980 da Maurizio Polo, nacque con lo scopo di divenire la soluzione per la produzione di vino di elevata qualità, intesa come un insieme di caratteristiche naturali, costanti e replicabili che rappresentano la vera differenza rispetto alla massiva e variabile produzione industriale.<br />
La costante volontà di mirare ad una crescente qualità ha permesso al Laboratorio Polo di ampliare, negli anni, l'offerta di <a href="/sistema-di-qualita#cert1">prove accreditate</a>, come evidenziato all'interno del sito internet dell'ente di accreditamento ACCREDIA.
          </p>

          <figure class="figure-padded">
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/services/laboratory-2815641.jpg')">
              <img :src="require('@/assets/services/laboratory-2815641.jpg')" alt="Partner Rossetto">
            </picture>
          </figure>

          <span class="bottom-anchor"></span>

          <span class="anchor" data-anchor="Microbiologia"></span>
          <h3>Microbiologia</h3>
          <h4>In seguito alla forte crescita della domanda di sicurezza alimentare, la nostra risposta è stata pronta e strutturata. I nostri specialisti sono in grado di offrire un servizio conforme ai requisiti legislativi.</h4>

          <figure class="figure-padded">
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/services/bacteria.jpg')">
              <img :src="require('@/assets/img/content/our-world-partner-rossetto-small.jpg')" alt="Partner Rossetto">
            </picture>
          </figure>

          <span class="bottom-anchor"></span>

          <span class="anchor" data-anchor="Chimica"></span>

          <h3>Chimica</h3>
          <h4>Per rispondere alle esigenze dei nostri clienti abbiamo reso disponibili innovativi approcci analitici per la determinazione di contaminanti, pesticidi, fitofarmaci, micotossine, metalli pesanti, plasticizzanti, cloroanisoli.</h4>

          <p>
            <a target="_blank" href="/pdf/2026/Report-analitico-pacchetto-plasma-metalli.pdf">Scarica documento: Report analitico pacchetto plasma metalli</a><br />
            <a target="_blank" href="/pdf/2026/Report-pacchetto-multiresiduale-pesticidi.pdf">Scarica documento: Report pacchetto multiresiduale pesticidi</a>
          </p>

          <figure class="figure-padded">
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/services/ricercatrice.jpg')">
              <img :src="require('@/assets/services/ricercatrice.jpg')" alt="Quality Rossetto">
            </picture>
          </figure>

          <span class="bottom-anchor"></span>

          <span class="anchor" data-anchor="Monitoraggio delle fermentazioni"></span>

          <h3>Monitoraggio delle fermentazioni</h3>
          <h4>Messo a punto nel 1990 e costantemente aggiornato, questo pacchetto analitico consente un'indagine profonda del fenomeno fermentativo, sia che si tratti di mosto, vino o base spumante.</h4>

          <p>
            Rende disponibili tutte le informazioni necessarie al controllo del processo di trasformazione e, quando necessario, permette di pilotarlo così da migliorare la qualità del prodotto.<br />
<br />
            Il monitoraggio richiede l'uso di numerose tecniche analitiche, tra le quali spicca la cromatografia liquida ad alte prestazioni (HPLC). Il chimismo della fermentazione è regolato da molteplici fattori, come le fonti azotate, gli amminoacidi e le vitamine del gruppo B, che fungono da biocatalizzatori esogeni nel mosto.<br />
<br />
            Particolare importanza riveste la ricerca e la quantificazione dei metaboliti dei lieviti, così da stabilirne lo stato vitale e la qualità fermentativa.<br />
<br />
            È dunque individuando in tempo reale eventuali squilibri, che si può intervenire tempestivamente allo scopo di rettificare importanti parametri quali, l'acidità volatile (con possibilità di ridurla), l'acidità totale, il pH, la gradazione, l'aroma e così via, scongiurando il decadimento organolettico del prodotto finito. (vedi PL-06)<br />
<br />
            <a target="_blank" href="/pdf/2026/report-analitici-di-monitoraggio.pdf">Scarica documento: report analitici di monitoraggio</a><br />
            <a target="_blank" href="/pdf/MONITORAGGIO DELLE FERMENTAZIONI.pdf">Scarica documento: Monitoraggio delle fermentazioni</a>
          </p>

          <figure class="figure-padded">
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/services/fermentazione-vino.jpg')">
              <img :src="require('@/assets/services/fermentazione-vino.jpg')" alt="World Accademy Rossetto">
            </picture>
          </figure>

          <span class="bottom-anchor"></span>

          <span class="anchor" data-anchor="Shelf-life"></span>

          <h3>Shelf-life</h3>
          <h4>Al fine di allungare la vita commerciale dei vini, sia bianchi che rossi, abbiamo messo a punto specifici e sofisticati metodi analitici, oltre ad additivi interamente naturali.</h4>

          <p>
            <a href="https://www.bioenologia.com/vino/ager">Approfondisci su bioenologia</a>
          </p>

          <figure class="figure-padded">
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/services/gocce-vino.jpg')">
              <img :src="require('@/assets/services/gocce-vino.jpg')" alt="Quality Rossetto">
            </picture>
          </figure>

          <span class="bottom-anchor"></span>

          <span class="anchor" data-anchor="Consulenza e formazione"></span>

          <h3>Consulenza e formazione</h3>
          <h4>Affianchiamo i produttori ed i loro collaboratori tramite attività strutturate di formazione ed aggiornamento sulle metodologie produttive, comprese quelle di spumantizzazione che impiegano il Metodo Classico o il Metodo Charmat, portando innovazione nella tradizione.</h4>

          <figure class="figure-padded">
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/services/consulente.jpg')">
              <img :src="require('@/assets/services/consulente.jpg')" alt="Quality Rossetto">
            </picture>
          </figure>

          <span class="bottom-anchor"></span>

          <span class="anchor" data-anchor="Interazioni con altri materiali"></span>

          <h3>Studio delle interazioni con altri materiali</h3>
          <h4>Al fine di assicurare la conformità e la qualità, è di fondamentale importanza verificare le interazioni tra i prodotti enologici e i materiali con cui questi vengono a contatto.</h4>

          <p>
            La loro determinazione è fondamentale per stabilire il grado di conservabilità del vino, ma soprattutto per il controllo della qualità delle attrezzature di cantina, degli additivi enologici e l'adeguatezza delle pratiche.
          </p>

          <accordion :elements="accordionDataProdotti" />

          <figure class="figure-padded">
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/services/tappi.jpg')">
              <img :src="require('@/assets/services/tappi.jpg')" alt="Quality Rossetto">
            </picture>
          </figure>

          <span class="bottom-anchor"></span>

          <span class="anchor" data-anchor="Analisi sensoriale"></span>

          <h3>Analisi sensoriale</h3>
          <h4>Forniamo un servizio di degustazione professionale per effettuare:</h4>

          <p>
            <ul>
              <li>
                <p>
                  Valutazioni organolettiche
                </p>
              </li>
              <li>
                <p>
                  Identificazione delle caratteristiche positive e dei difetti
                </p>
              </li>
              <li>
                <p>
                  Pareri tecnici per la definizione di controversie sulla qualità dei prodotti
                </p>
              </li>
            </ul>
          </p>

          <figure class="figure-padded">
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/services/degustazione-vini.jpg')">
              <img :src="require('@/assets/services/degustazione-vini.jpg')" alt="Quality Rossetto">
            </picture>
          </figure>

          <span class="bottom-anchor"></span>

          <span class="anchor" data-anchor="Certificazione"></span>

          <h3>Certificazione</h3>
          <h4>Grazie alla ultratrentennale esperienza e al conseguemento dei più importanti <router-link :to="{ name: 'greenSpirit' }">accreditamenti del settore</router-link>, in tempi rapidi, possiamo assistere i nostri clienti per certificazioni ufficiali</h4>

          <p>
            <ul>
              <li>
                <p>
                  per l'esportazione in tutto il mondo
                </p>
              </li>
              <li>
                <p>
                  per il controllo della qualità globale per la G.D.O. italiana, europea ed extra-europea, per soddisfare le richieste dei singoli prodotti specifici
                </p>
              </li>
              <li>
                <p>
                  del monitoraggio H.A.C.C.P. previsto dal manuale di autocontrollo
                </p>
              </li>
              <li>
                <p>
                  per la redazione di documenti peritali o per controversie di carattere legale
                </p>
              </li>
              <li>
                <p>
                  per la verifica dell'idoneità alla D.O.C. o D.O.G.C.
                </p>
              </li>
            </ul>
          </p>

          <figure>
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/services/bottiglia-vino.jpg')">
              <img :src="require('@/assets/services/bottiglia-vino.jpg')" alt="Quality Rossetto">
            </picture>
          </figure>

          <span class="bottom-anchor"></span>
        </template>
      </two-columns-content>
    </content-wrapper>

    <global-footer />
  </div>
</template>

<script>
import guards from './SingleView/guards'
import garbage from './SingleView/garbage'
import backgrounds from './SingleView/backgrounds'
import HeroBlock from '../components/HeroBlock'
import ContentWrapper from '../components/ContentWrapper'
import GlobalFooter from '../components/GlobalFooter'
import TwoColumnsContent from '../components/ContentWrapper/TwoColumnsContent'
import Accordion from '../components/Accordion'
import RossettoButton from '../components/RossettoButton'
import ViewBackground from '../components/ViewBackground'
import VisualCounter from '../components/VisualCounter'
import { mapMutations } from 'vuex'

export default {
  mixins: [ guards, garbage, backgrounds ],
  components: {
    HeroBlock,
    ContentWrapper,
    GlobalFooter,
    TwoColumnsContent,
    Accordion,
    RossettoButton,
    ViewBackground,
    VisualCounter
  },
  data: () => ({
    title: 'Servizi',
    subtitle: 'Expertise certificata, efficacia garantita.',
    bgName: 'services',
    accordionDataProdotti: require('../components/Accordion/servizi.json')
  }),
  methods: {
    ...mapMutations('animations', [
      'updateMouseCursor'
    ])
  }
}
</script>

<style lang="scss">
.services {
  .block--header {
    h2 {
      max-width: 780px;
    }
  }
}
</style>
